import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';
import { environment } from '../../../../../environments/environement';

export const myRxStompConfig: InjectableRxStompConfig = {
  brokerURL: environment.apiUrl.replace(/^http/, 'ws') + '/ws',

  connectHeaders: {},
  reconnectDelay: 1000,
  heartbeatIncoming: 10000,
  heartbeatOutgoing: 5000,
  debug: (): void => {},
};
